import React, { Suspense, lazy } from 'react';
import { Routes, Route } from "react-router-dom";
import PublicLayout from "./PublicLayout";
import AdminLayout from "./AdminLayout";
import AdminProtectedRoute from "./AdminProtectedRoute";

const Home = lazy(() => import('./Home'));
const About = lazy(() => import('./About'));
const Contact = lazy(() => import('./Contact'));
const DholeraSir = lazy(() => import('./DholeraSir'));
const Planning = lazy(() => import('./Planning'));
const Pricing = lazy(() => import('./Pricing'));
const EnquiryForm = lazy(() => import('./EnquiryForm'));
const Opportunities = lazy(() => import('./Opportunities'));
const Expressway = lazy(() => import('./Expressway'));
const Metro = lazy(() => import('./Metro'));
const Freight = lazy(() => import('./Freight'));
const Infrastructure = lazy(() => import('./Infrastructure'));
const Seaport = lazy(() => import('./Seaport'));
const SolarPark = lazy(() => import('./SolarPark')); 
const RiverFront = lazy(() => import('./RiverFront'));
const Gallery = lazy(() => import('./Gallery'));
const DiamondCircle = lazy(() => import('./DiamondCircle'));
const NotFoundPage = lazy(() => import('./NotFoundPage'));
const AdminLogin = lazy(() => import('./AdminLogin'));
const AdminDashboard = lazy(() => import('./AdminDashboard'));
const PagesList = lazy(() => import('./PageList'));
const PageEditor = lazy(() => import('./PageEditor'));
const CarouselAdmin = lazy(() => import('./CarouselAdmin'));
const AboutAdmin = lazy(() => import('./AboutAdmin'));
const AdminDholeraSir = lazy(() => import('./AdminDholeraSir'));
const AdminInvestment = lazy(() => import('./AdminInvestment'));
const AdminPricing = lazy(() => import('./AdminPricing'));
const AdminGallery = lazy(() => import('./AdminGallery'));
const AdminContact = lazy(() => import('./AdminContact'));
const AdminPlanning = lazy(() => import('./AdminPlanning'));
const Adminabouthome = lazy(() => import('./Adminabouthome'));
const AdminFeatureSection = lazy(() => import('./AdminFeatureSection'));
const AdminFeaturedInvestment = lazy(() => import('./AdminFeaturedInvestment'));
const AdminProcessSection = lazy(() => import('./AdminProcessSection'));
const AdminConnectivities = lazy(() => import('./AdminConnectivities'));
const AdminTeamSection = lazy(() => import('./AdminTeamSection'));
const AdminCtaSection = lazy(() => import('./AdminCtaSection'));
const AdminReviewSection = lazy(() => import('./AdminReviewSection'));
const AdminContactSection = lazy(() => import('./AdminContactSection'));
const DynamicDetailPage = lazy(() => import('./DynamicDetailPage'));
const PageBuilder = lazy(() => import('./PageBuilder'));
const BlogsMain = lazy(() => import('./BlogsMain'));
const BlogDetailPage = lazy(() => import('./BlogDetailPage'));
const AdminSocialIcons = lazy(() => import('./AdminSocialIcons'));
const AdminHome = lazy(() => import('./AdminHome'));
const AdminContactForm = lazy(() => import('./AdminContactForm'));
const EnquiryFormAdmin = lazy(() => import('./EnquiryFormAdmin'));
const InvestmentFormAdmin = lazy(() => import('./InvestmentFormAdmin'));
const BlogList = lazy(() => import('./BlogList'));
const AdminFooter = lazy(() => import('./AdminFooter'));
const AdminDisclaimer = lazy(() => import('./AdminDisclaimer'));
const AdminPrivacyPolicy = lazy(() => import('./AdminPrivacyPolicy'));
const AdminTermsConditions = lazy(() => import('./AdminTermsConditions'));
const PrivacyPolicy = lazy(() => import('./PrivacyPolicy'));
const TermsConditions = lazy(() => import('./TermsConditions'));
const Disclaimer = lazy(() => import('./Disclaimer'));

const SiteRoutes = () => {
  return (
    <Suspense fallback={<div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"100vh"}}><h2>Loading...</h2></div>}>
    <Routes>
      {/* PUBLIC WEBSITE */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/dholera-SIR" element={<DholeraSir />} />
        <Route path="/planning" element={<Planning />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/enquiry-form" element={<EnquiryForm />} />
        <Route path="/investment-opportunities" element={<Opportunities />} />
        {/* <Route path="/dholera-international-airport" element={<Airport />} /> */}
        <Route path="/ahmedabad-dholera-expressway" element={<Expressway />} />
        <Route path="/dholera-metro-rail-project" element={<Metro />} />
        <Route path="/dedicated-freight-corridor" element={<Freight />} />
        <Route
          path="/dholera-smart-infrastructure"
          element={<Infrastructure />}
        />
        <Route path="/dholera-sea-port" element={<Seaport />} />
        <Route path="/dholera-solar-park" element={<SolarPark />} />
        <Route path="/dholera-artificial-riverfront" element={<RiverFront />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/dholera-diamond-circle" element={<DiamondCircle />} />
        <Route path="/:slug" element={<DynamicDetailPage />} />
        <Route path="/blogs" element={<BlogsMain />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route path="/blogs/category/:category" element={<BlogsMain />} />
        <Route path="/blogs/tag/:tag" element={<BlogsMain />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
      </Route>

      {/* ADMIN */}
      {/* ADMIN */}

      {/* Public admin route */}
      <Route path="/admin-login" element={<AdminLogin />} />

      {/* Protected admin routes */}
      <Route element={<AdminProtectedRoute />}>
        <Route element={<AdminLayout />}>
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/pages" element={<PagesList />} />
          <Route path="/admin/blogs" element={<BlogList />} />
          <Route path="/admin/pages/:slug/edit" element={<PageBuilder />} />
          <Route path="/admin/pages/home-page-seo" element={<AdminHome />} />
          <Route path="/admin/pages/new" element={<PageBuilder />} />
          <Route path="/admin/pages/carousel" element={<CarouselAdmin />} />
          <Route
            path="/admin/pages/feature-section"
            element={<AdminFeatureSection />}
          />
          <Route
            path="/admin/pages/about-home-page"
            element={<Adminabouthome />}
          />
          <Route
            path="/admin/pages/featured-investment-home-page"
            element={<AdminFeaturedInvestment />}
          />
          <Route
            path="/admin/pages/process-section-home-page"
            element={<AdminProcessSection />}
          />
          <Route
            path="/admin/pages/team-section-home-page"
            element={<AdminTeamSection />}
          />
          <Route
            path="/admin/pages/cta-section-home-page"
            element={<AdminCtaSection />}
          />
          <Route
            path="/admin/pages/review-section-home-page"
            element={<AdminReviewSection />}
          />
          <Route
            path="/admin/pages/contact-section-home-page"
            element={<AdminContactSection />}
          />
          <Route path="/admin/pages/about" element={<AboutAdmin />} /> 

          <Route
            path="/admin/pages/dholera-sir"
            element={<AdminDholeraSir />}
          />
          <Route
            path="/admin/pages/investment-opportunities"
            element={<AdminInvestment />}
          />
          <Route
            path="/admin/pages/connectivities-home-page"
            element={<AdminConnectivities />}
          />
          <Route path="/admin/pages/pricing" element={<AdminPricing />} />
          <Route path="/admin/pages/gallery" element={<AdminGallery />} />
          <Route path="/admin/pages/contact" element={<AdminContact />} />
          <Route
            path="/admin/pages/dholera-planning"
            element={<AdminPlanning />}
          />
          <Route path="/admin/pages/disclaimer" element={<AdminDisclaimer />} />
          <Route path="/admin/pages/privacy-policy" element={<AdminPrivacyPolicy />} />
          <Route path="/admin/pages/terms-conditions" element={<AdminTermsConditions />} />
          <Route path="/admin/page-builder" element={<PageBuilder />} />
          <Route path="/admin/page-builder/:slug?" element={<PageBuilder />} />
          <Route path="/admin/pages/edit/:slug" element={<PageBuilder />} />
          <Route
            path="/admin/pages/side-social-icons"
            element={<AdminSocialIcons />}
          />
          <Route path="/admin/pages/footer" element={<AdminFooter />} />
          <Route
            path="/admin/pages/contact-form-queries"
            element={<AdminContactForm />}
          />
          <Route
            path="/admin/pages/enquiry-form-queries"
            element={<EnquiryFormAdmin />}
          />
          <Route
            path="/admin/pages/investment-form-queries"
            element={<InvestmentFormAdmin />}
          />
        </Route>
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    </Suspense>
  );
};

export default SiteRoutes;
